import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getMe } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // { username, role, clientId? }
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem('saas_token');
    if (!token) { setLoading(false); return; }
    try {
      // GET api/auth/me → { username, role, clientId?, active?, expiresAt? }
      const me = await getMe();
      setUser(me);
    } catch {
      localStorage.removeItem('saas_token');
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);

  /**
   * signIn — llamado después de un login exitoso
   * loginData = { token, role, username, clientId? }  ← shape exacta del PHP
   */
  const signIn = (loginData) => {
    localStorage.setItem('saas_token', loginData.token);
    setUser({
      username:  loginData.username,
      role:      loginData.role,
      clientId:  loginData.clientId ?? null,
      active:    loginData.active   ?? true,
      expiresAt: loginData.expiresAt ?? null,
    });
  };

  const signOut = () => {
    localStorage.removeItem('saas_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
